<template>
  <div data-test="horseContacts">
    <v-card v-for="c in contacts" :key="c.id" class="pa-4 mb-2">
      <div
        v-if="showActions"
        data-test="actions"
        style="float: right"
        class="mt-4"
      >
        <v-btn-icon
          icon
          location="right"
          size="small"
          class="mx-1 bg-edit-green"
          @click="$emit('update', c)"
        >
          <v-icon size="small" color="white"> $edit </v-icon>
        </v-btn-icon>
        <v-btn-icon
          location="right"
          icon
          color="remove"
          class="mx-1"
          size="small"
          @click="$emit('remove', c)"
        >
          <v-icon size="small" color="white"> $iconTrash </v-icon>
        </v-btn-icon>
      </div>

      <template v-if="c.contactType == 'PERSON_REFERENCE'">
        <b>{{ showDisplayName(c.person) }}</b>
      </template>
      <template v-else-if="c.contactType == 'PERSON_INFO'">
        <b>{{
          showDisplayName({
            firstName: c.firstName,
            lastName: c.lastName
          })
        }}</b>
      </template>
      <template v-else-if="c.contactType == 'ORGANISATION_REFERENCE'">
        <b>{{ c.organisation ? c.organisation.name : "" }}</b
        ><br />
        {{ c.organisationIdcode }}
      </template>
      <template v-else-if="c.contactType == 'ORGANISATION_INFO'">
        <b>{{ c.organisationName }}</b
        ><br />
        {{ c.organisationIdcode }}
      </template>
      <div class="mb-2 mt-2">
        <AppShowAddress :address="formAddress(c)" />
      </div>
      <div v-if="c.email && c.phone" class="mb-2">
        {{ c.email }}<br v-if="c.phone" />
        {{ c.phone }}
      </div>
      <div>
        {{ $t("horses:horseApplication.ownerForm.activeFrom.label") }}
        {{ $dayjs.date(c.activeFrom) }}
        <template v-if="c.ownershipShare">
          <br />
          {{ $t("horses:horseApplication.ownerForm.ownershipShare.label") }}
          {{ returnLocalisedPercent(c.ownershipShare) }}
        </template>
      </div>
    </v-card>
  </div>
</template>
<script>
import gql from "fraql";
import { getFederationConfiguration } from "@composables/masterdata/config";
import AppShowAddress from "@AppShows/AppShowAddress.vue";
export default {
  name: "AppShowHorseContacts",
  components: { AppShowAddress },
  props: {
    contacts: {
      type: Array,
      default: () => []
    },
    showActions: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update", "remove"],
  setup() {
    return {
      ...getFederationConfiguration()
    };
  },
  methods: {
    formAddress(c) {
      if (c.organisation && c.organisation.address) {
        return {
          addressText: c.organisation.address?.addressText ?? null,
          addressIndex: c.organisation.address?.addressIndex ?? null,
          addressCity: c.organisation.address?.addressCity ?? null,
          addressBox: c.organisation.address?.addressBox ?? null,
          addressHouse: c.organisation.address?.addressHouse ?? null,
          addressCountry: c.organisation.address?.addressCountry?.name ?? null
        };
      } else if (c.person && c.person.address) {
        return {
          addressText: c.person.address?.addressText ?? null,
          addressIndex: c.person.address?.addressIndex ?? null,
          addressCity: c.person.address?.addressCity ?? null,
          addressBox: c.person.address?.addressBox ?? null,
          addressHouse: c.person.address?.addressHouse ?? null,
          addressCountry: c.person.address?.addressCountry?.name ?? null
        };
      }
      return {
        addressText: c.addressText,
        addressIndex: c.addressIndex,
        addressCity: c.addressCity,
        addressHouse: c.addressHouse,
        addressCountry: c.addressCountry?.name ?? null
      };
    }
  }
};

export const HorseContactFragment = gql`
  fragment _ on HorseContact {
    id
    rolecode
    contactType
    personId
    person {
      id
      firstName
      lastName
      email

      address {
        id
        ${AppShowAddress.fragments.addressFields}
        addressCity
        addressText
        addressIndex
        addressHouse
        addressCountry @client {
          id
          name
        }
      }
    }
    firstName
    lastName
    organisationId
    organisation {
      id
      name
      businessRegCode
      email

      address {
        id
        ${AppShowAddress.fragments.addressFields}
        addressCity
        addressText
        addressIndex
        addressHouse
        addressCountryId
        addressCountry @client {
          id
          name
        }
      }
    }
    organisationName
    organisationIdcode
    email
    phone
    addressCountryId
    addressCountry @client {
      id
      name
    }
    addressCity
    addressText
    addressIndex
    addressHouse
    ownershipShare
    activeFrom
    activeUntil
  }
`;
</script>
